import React from 'react';
import { getItemTarget, isLinkItem } from '../utils/utils';
import InternalIcon from '../../icon/internal';
import ItemIcon from './item-icon';
import styles from './styles.css.js';
var ExternalIcon = function (_a) {
    var item = _a.item;
    var disabled = item.disabled, external = item.external, externalIconAriaLabel = item.externalIconAriaLabel;
    if (!external) {
        return null;
    }
    var icon = React.createElement(InternalIcon, { variant: disabled ? 'disabled' : 'normal', name: "external" });
    return externalIconAriaLabel ? (React.createElement("span", { role: "img", "aria-label": externalIconAriaLabel }, icon)) : (icon);
};
var LinkItem = function (_a) {
    var item = _a.item, disabled = _a.disabled, itemRef = _a.itemRef;
    if (!isLinkItem(item)) {
        return null;
    }
    return (
    // eslint-disable-next-line react/jsx-no-target-blank
    React.createElement("a", { ref: itemRef, className: styles['item-element-inner'], href: !disabled ? item.href : undefined, target: getItemTarget(item), rel: item.external ? 'noopener noreferrer' : undefined },
        React.createElement(ItemIcon, { name: item.iconName, url: item.iconUrl, svg: item.iconSvg, alt: item.iconAlt }),
        React.createElement("span", null,
            item.text,
            " ",
            React.createElement(ExternalIcon, { item: item }))));
};
export default LinkItem;
//# sourceMappingURL=link-item.js.map